var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "root" },
    [
      _c(
        "w-button",
        {
          staticClass: "close-button",
          attrs: { flat: "" },
          on: {
            click: function ($event) {
              return _vm.close($event)
            },
          },
        },
        [_c("w-fa", { attrs: { icon: "times" } })],
        1
      ),
      _c("img", { staticClass: "image", attrs: { src: _vm.src } }),
      _c(
        "div",
        { staticClass: "controls" },
        [
          _c(
            "w-button",
            {
              attrs: { flat: "" },
              on: {
                click: function ($event) {
                  return _vm.download()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "download", size: "3x" } })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }